import { bind } from 'decko'
import { LiveNodeList } from 'live-node-list'

export default class Accordion {
  tabs = new LiveNodeList('[role="tab"]')

  constructor() {
    this.registerListeners()
  }

  registerListeners() {
    this.tabs.addEventListener('click', this.handleClick)
  }

  @bind
  handleClick() {
    const target = event.currentTarget || event.target

    if (target.dataset.exclusive === 'true') {
      target.parentNode.querySelectorAll('[role="tab"]').forEach(tab => {
        tab.setAttribute('aria-expanded', 'false')
      })
    }

    target.setAttribute(
      'aria-expanded',
      (target.getAttribute('aria-expanded') === 'false').toString(),
    )
    document
      .querySelectorAll(
        `[role="tab"][aria-controls="${target.getAttribute('aria-controls')}"]`,
      )
      .forEach(tab => {
        tab.setAttribute('aria-expanded', target.getAttribute('aria-expanded'))
      })

    // Remove hashes to allow URL-targeted accordion elements to be closed
    history.pushState(
      '',
      document.title,
      `${window.location.pathname}${window.location.search}`,
    )
  }
}
